'use strict';

var PARSE_ERROR_ATTR = 'parse-error';
var naPhone = /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/,
    usernameRegex = /^[A-Za-z0-9 .àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ'-]{2,50}$/;

var regex = {
    phone: {
        us: naPhone,
        ca: naPhone,
        fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
        it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
        jp: /^(0\d{1,4}- ?)?\d{1,4}-\d{4}$/,
        cn: /.*/,
        gb: /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/
    },
    postal: {
        us: /^\d{5}(-\d{4})?$/,
        ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
        fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
        it: /^([0-9]){5}$/,
        jp: /^([0-9]){3}[-]([0-9]){4}$/,
        cn: /^([0-9]){6}$/,
        gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/
    },
    cvn: /^[0-9*]*$/,
    po: /^[a-zA-Z0-9_-]*$/,
    notCC: /^(?!(([0-9 -]){13,19})).*$/,
    masked		: /^\*\*\*\*\*\*\*\*\*\*\*/,
    visa		: /^4/,
    mastercard	: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[0-1]|2720)/,
    amex		: /^3[47]/,
    discover	: /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/,
    password	: /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9_@./#&+-^*%<>!$~`\?]+)$/,
    promocouponRegex : /^[A-Za-z0-9 -]{0,20}$/,
    email		: /^[-a-z0-9.!#$%&'*+/=?^_`{|}~-]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,
    zip			: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1}\s\d{1}[A-Z]{1}\d{1}$/
};


var FIELD_VALIDATORS = [
    { suffix: ['firstName', 'firstname'], rule: 'validatefirstname' },
    { suffix: ['lastName', 'lastname'], rule: 'validatelastname' },
    { suffix: ['emailconfirm'], rule: 'validateconfirmemail' },
    { suffix: ['password', 'Password'], rule: 'validatepassword' },
    { suffix: ['passwordconfirm'], rule: 'validateconfirmpassword' },
    { suffix: ['postalCode'], rule: 'validatepostalcode' },
    { suffix: ['phone'], rule: 'validatephone' },
    { suffix: ['bml_po'], rule: 'poformat' }
];

function applyFieldValidators(name, rules, messages, errorAttr) {
    FIELD_VALIDATORS.forEach(function(validator) {
        var matches = validator.suffix.some(function(s) { return name.endsWith(s); });
        if (matches) {
            rules[name][validator.rule] = true;
            messages[name][validator.rule] = errorAttr;
        }
    });
}

module.exports = {
    addInputValidations : function(form) {
        var $form = form;
        var rules = {};
        var messages = {};
        $form.find('input, select').each(function () {
            var $element = $(this);
            var name = $(this).attr('name');
            /* var id = $(this).attr('id');
            var type= $(this).attr('type'); */
            rules[name] = {};
            messages[name] = {};
            if ($element.attr('required')) {
                rules[name] = { required: true };
                messages[name].required = $element.attr('missing-error');
            }

            if (name) {
                applyFieldValidators(name, rules, messages, $element.attr(PARSE_ERROR_ATTR));

                /* if (name === "quantity") {
                    rules[name].min = ($element.attr('min') - 1);
                    messages[name].min = $element.attr(PARSE_ERROR_ATTR);
                }
                if (name === "custom-select") {
                    rules[name].valueNotEquals = "";
                    messages[name].valueNotEquals = $element.attr('missing-error');
                }

                if (id === "billingPo") {
                    rules[name].poFormat = true;
                    messages[name].poFormat = $element.attr(PARSE_ERROR_ATTR);
                    messages[name].maxlength = $element.attr(PARSE_ERROR_ATTR);
                    messages[name].minlength = $element.attr(PARSE_ERROR_ATTR);
                }
                if (id === "promoCode") {
                    rules[name].promoCodeFormat = true;
                    messages[name].promoCodeFormat = $element.attr(PARSE_ERROR_ATTR);
                    messages[name].maxlength = $element.attr(PARSE_ERROR_ATTR);
                    messages[name].minlength = $element.attr(PARSE_ERROR_ATTR);
                } */
            }
        });

        $form.validate({
            ignore: ":hidden, .ignoreValidation",
            rules: rules,
            messages: messages,
            errorClass: "invalid-feedback",
            errorElement: "div",
            errorElementClass: 'is-invalid',
            highlight: function(element, errorClass) {
                $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            unhighlight: function(element, errorClass) {
                $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
            },
            errorPlacement: function (error, element) {
                error.insertAfter(element);
            }
        });

        jQuery.validator.addMethod("validatefirstname", function( value, element ) {
            return usernameRegex.test($.trim(value)) || !(value);
        });

        jQuery.validator.addMethod("validatelastname", function( value, element ) {
            return usernameRegex.test($.trim(value)) || !(value);
        });

        $.validator.methods.email = function( value, element ) {
            var isOptional = this.optional(element);
            var isValid = regex.email.test($.trim(value));
            return isOptional || isValid;
        }

        $.validator.methods.validateconfirmemail = function( value, element ) {
            var $elementForm = $(element).closest("form");
            var isOptional = this.optional(element);
            var isValid = $elementForm.find('.femail').val().toLowerCase() === $elementForm.find('.validateconfirmemail').val().toLowerCase();

            return isOptional || isValid;
        }

        $.validator.addMethod("validatepassword", function(value, element) {
            return this.optional( element ) || regex.password.test($.trim(value));
        });

        $.validator.addMethod("validateconfirmpassword", function( value, element ) {
            var $elementForm = $(element).closest("form");
            var isOptional = this.optional(element);
            var isValid = $elementForm.find('.fpassword').val() === $elementForm.find('.validateconfirmpassword').val();

            return isOptional || isValid;
        });

        $.validator.addMethod("validatepostalcode", function (value, element) {
            var isValid;
            if($(".country").val()=== "US") {
                isValid = regex.postal.us.test(value);
            } else if($(".country").val()=== "CA"){
                isValid = regex.postal.ca.test(value);
            } else{
                isValid = false;
            }

            const button = '.search-addnewschool';
            if (isValid && button) {
                $(button).removeAttr('disabled');
            } else {
                $(button).attr('disabled','disabled');
            }
            return isValid;
        });

        $.validator.addMethod("validatephone", function(value, element) {
            var country = $(element).closest('form').find('.country');
            var rgx = regex.phone[(country.val() ? country.val().toLowerCase() : 'us')];
            var isOptional = this.optional(element);
            var isValid = rgx.test($.trim(value));

            return isOptional || isValid;
        });

        $.validator.addMethod("poformat", function(value, element) {
            return this.optional( element ) || regex.po.test( value );
        });

        /* jQuery.validator.addMethod("valueNotEquals", function(value, element, param) {
            return this.optional(element) || (value === param);
        }, "");

        jQuery.validator.addMethod("promoCodeFormat", function(value, element) {
            var pattern = /^[0-9]*$/;
            return this.optional( element ) || pattern.test( value );
        }, "");
         */
        jQuery.validator.setDefaults({
            highlight: function(element, errorClass, validClass) {
                // default function
                if (element.type === "radio") {
                    this.findByName(element.name).addClass(errorClass).removeClass(validClass);
                } else {
                    $(element).addClass(errorClass).removeClass(validClass);
                }
                // custom additions
                if (element.type === "search") {
                    $(element).parent().addClass(errorClass).removeClass(validClass);
                }
            },
            unhighlight: function(element, errorClass, validClass) {
                // default function
                if (element.type === "radio") {
                    this.findByName(element.name).removeClass(errorClass).addClass(validClass);
                } else {
                    $(element).removeClass(errorClass).addClass(validClass);
                }
                // custom additions
                if (element.type === "search") {
                    $(element).parent().removeClass(errorClass).addClass(validClass);
                }
            },
        });
    },
    checkValidation: function (element) {
        var $element = element;
        var $form = $element.closest('form');
        if ($form.length) {
            var validator = $form.validate();
            validator.element($element);
            return validator.checkForm();
        }
    },
    checkFormValid: function(form) {
        var $form = form;
        return $form.valid();
    }
};
